import { useEffect, useState } from 'react';
import { prizeWasWonByGuest } from 'utils/api/prizes';

export const useGuestDetails = (prizeWinId?: string, emailAddress?: string) => {
  const [guestDetails, setGuestDetails] = useState<{
    userId: string;
    emailAddress: string;
    wonByGuest: string;
  } | null>(null);
  useEffect(() => {
    (async () => {
      if (emailAddress && prizeWinId) {
        const prizeWonByGuestCheckResult = await prizeWasWonByGuest(
          prizeWinId,
          emailAddress
        );
        if (prizeWonByGuestCheckResult.wonByGuest) {
          setGuestDetails(prizeWonByGuestCheckResult);
        }
      }
    })();
  }, [emailAddress, prizeWinId]);
  return {
    guestDetails,
  };
};
